<template>
  <div class="form-group">
    <label :for="id" class="form-label">
      {{ label }} 
      <span v-if="required" class="required-mark">*</span>
    </label>
    <div class="textarea-wrapper">
      <textarea 
        class="form-textarea" 
        :id="id" 
        :rows="rows"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @focus="isFocused = true"
        @blur="isFocused = false"
        :required="required"
        :placeholder="placeholder"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTextarea',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 6
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isFocused: false
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  letter-spacing: -0.01em;
}

.required-mark {
  color: #ef4444;
  margin-left: 2px;
}

.textarea-wrapper {
  position: relative;
}

.form-textarea {
  width: 100%;
  padding: 14px 16px;
  font-size: 1rem;
  color: #1a1f3a;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  font-family: inherit;
  resize: vertical;
  min-height: 120px;
  line-height: 1.6;
}

.form-textarea::placeholder {
  color: #9ca3af;
}

.form-textarea:hover {
  border-color: #d1d5db;
  background: #ffffff;
}

.form-textarea:focus {
  background: #ffffff;
  border-color: #2a5298;
  box-shadow: 0 0 0 4px rgba(42, 82, 152, 0.1);
}
</style>

